import React from 'react'
import ReactDOM from 'react-dom/client'

/* CSS */
import './design/css/app.css'
import './design/css/preloader.css'
import './design/css/bet.css'
import './design/css/play.css'
import './design/css/dealer.css'
import './design/css/player.css'
import './design/css/buttons.css'
import './design/css/timing.css'
import './design/css/busy.css'
import './design/css/special.css'
import './design/css/viprates.css'
import './design/css/jackpot.css'
import './design/css/jackpotwin.css'
import './design/css/terminal.css'

import App from './App'
import reportWebVitals from './reportWebVitals'


const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(<App />)

reportWebVitals()